import React, { useEffect, useState } from 'react';
import i18n from '@i18next/i18n';
import Modal from '@tencent/dui/lib/components/Modal';
import { SnapshotList, SnapshotListFromServer } from './snapshot-list';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { EditEvents } from '@src/slide/domain/slide-app/core/interfaces/event.interface';
import type { SnapshotDataItemsModel, SnapshotStorage } from '@tencent/slide-sdk-persistent/src/snapshot-manager';

interface IProps {
    visible?: boolean;
    storage?: SnapshotStorage;
    exportSnapshotFile(snapshot: SnapshotDataItemsModel): Promise<void>;
    downloadPPT(): void;
    closeModal?(): void;
}

export function SnapshotRecovery(props: IProps) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        let unbindFn: () => void;
        SlideDataServices.EventManager.promise().then((event) => {
            unbindFn = event.on(EditEvents.ShowSnapShotModal, () => {
                setVisible(true);
            });
        });

        return () => unbindFn?.();
    }, []);

    useEffect(() => {
        setVisible(!!props.visible);

        return () => {};
    }, [props.visible]);

    const closeModal = () => {
        setVisible(false);
        props.closeModal?.();
    };

    if (!visible) return null;
    const renderContent = SlideDataServices.ClientVarsService()?.isLocalEdit()
        ? () => (
            <React.Fragment>
                <SnapshotList
                    visible={visible}
                    exportSnapshotFile={snapshot => props.exportSnapshotFile(snapshot)}
                    storage={props.storage}
                />
            </React.Fragment>
        )
        : () => (
            <React.Fragment>
                <div style={{ fontWeight: 'bold' }}>{i18n.t('本地备份')}</div>
                <SnapshotList
                    visible={visible}
                    exportSnapshotFile={snapshot => props.exportSnapshotFile(snapshot)}
                    storage={props.storage}
                />
                <div style={{ fontWeight: 'bold' }}>{i18n.t('远程备份')}</div>
                <SnapshotListFromServer
                    visible={visible}
                    exportSnapshotFile={() => props.downloadPPT()}
                />
            </React.Fragment>
        );


    return (
        <Modal
            title={i18n.t('备份')}
            style={{ width: '480px', height: '80vh' }}
            maskStyle={{ zIndex: 10000 }}
            type="basic"
            visible={visible}
            onCancel={closeModal}
            onOk={closeModal}
            cancelText={null}
            okText={i18n.t('关闭')}
            containerDom={document.body}
        >
            <div style={{ width: '100%', height: 'calc(80vh - 180px)', overflow: 'auto' }}>
                {renderContent()}
            </div>
        </Modal>

    );
}
